import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';

import FormCard from 'src/components/ui/FormCard';

import DefaultForm from '../DefaultForm';
import { useFormPersonNumber } from '../hooks/useFormPersonNumber';

const DefaultFormCPersonNumber = (props) => {
	const {
		isPlain,
		serverError,
		onSubmit,
		onCancel,
		fullHeight,
		values,
		...rest
	} = props;

	const handleSubmit = useCallback(
		async (values) => {
			if (onSubmit) {
				await onSubmit(values);
			}
		},
		[onSubmit],
	);

	const { shape, initialValues, validationSchema } = useFormPersonNumber({
		values,
	});

	const form = <DefaultForm {...shape} {...rest} />;

	if (isPlain) return form;

	let result = (
		<Formik
			onSubmit={handleSubmit}
			initialValues={initialValues}
			validationSchema={validationSchema}
			validateOnChange={false}
		>
			{(formikProps) => {
				return (
					<FormCard
						title="Новое контактное лицо"
						error={serverError}
						fullHeight={fullHeight}
						onSubmit={formikProps.handleSubmit}
						onCancel={onCancel}
						onAccept={formikProps.submitForm}
						isLoading={formikProps.isSubmitting}
					>
						{form}
					</FormCard>
				);
			}}
		</Formik>
	);

	return result;
};

DefaultFormCPersonNumber.propTypes = {
	...DefaultForm.propTypes,
	isPlain: PropTypes.bool,
	fullHeight: PropTypes.bool,
};

export default DefaultFormCPersonNumber;
